import React, {  } from "react";

import { Col, Row } from "react-bootstrap";

import { observer } from "mobx-react";


import { BottomsheetDropdown } from "components";

const ImmediateAnnuityPlan = ({ form, data }) => {
 
  return (
    <div className="">
      <div className="mx-0 py-4">
        {/* <Col md={6} className="col-12">
          <div className="shadow p-3 bg-white rounded mt-4 mb-3"> */}
            {/* <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("premium-term").label}
            </div> */}
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle={form.$("premium-term").label}
              menuList={form.$("premium-term").extra.optionList}
              value={form.$("premium-term").value}
              onSelect={form.$("premium-term").onChange}
            />
          {/* </div>
        </Col> */}
      </div>
    </div>
  );
};

export default observer(ImmediateAnnuityPlan);
